export default __webpack_public_path__ + "static/media/mid-k-1-thumb.fa13da16.jpg";